import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const tripService = {
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.trip.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.trip.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },

  async create(data) {
      const response = await apiClient.post(endPoints.trip.create, data);
      return response.data;
  },
   async update(id,data) {
      const response = await apiClient.post(`${endPoints.trip.update}/${id}`, data);
      return response.data;
  },
  async toggleActivate(id) {
      const response = await apiClient.patch(`${endPoints.trip.toggleActivate}/${id}`);
      return response.data;
  },
  async edit(id) {
      const response = await apiClient.get(`${endPoints.trip.edit}/${id}`);
      return response.data;
  },
  async deleteImage(id) {
      const response = await apiClient.delete(`${endPoints.trip.deleteImage}/${id}`);
      return response.data;
  },
  async getDetail(id) {
      const response = await apiClient.get(`${endPoints.trip.getDetail}/${id}`);
      return response.data;
  },
  async deleteAsync(id) {
      const response = await apiClient.delete(`${endPoints.trip.delete}/${id}`);
      return response.data;
  },
   async getDropdownAsync(cityId, categoryId) {
    const response = await apiClient.get(`${endPoints.trip.getDropdown}/${cityId}/${categoryId}`);
    return response.data;
  },
  // async getDropdownAsync() {
  //   const response = await apiClient.get(`${endPoints.trip.getDropdown}`);
  //   return response.data;
  // },
   async getTripUnavailableDatesAsync(tripId) {
    const response = await apiClient.get(
      `${endPoints.trip.getTripUnavailableDates}/${tripId}/unavailable-dates`,
    );
    return response.data;
  },
};
